import type { PaletteOptions } from '@mui/material/styles/createPalette';

export const palette: PaletteOptions = {
  mode: 'light',
  common: {
    white: '#FFFFFF',
    black: '#071B3A',
  },
  primary: {
    main: '#6948EB',
    dark: '#5E3CE1',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#EEF2FD',
    contrastText: '#6948EB',
  },
  text: {
    primary: '#071B3A',
    secondary: '#071B3ACC',
    disabled: '#D4DFF9',
  },
  error: {
    main: '#FCEAEA',
    light: '#F7CBCB',
    contrastText: '#E02727',
  },
  warning: {
    main: '#CF6300',
    light: '#F3DAC2',
    contrastText: '#CF6300',
  },
  success: {
    main: '#F2F9F5',
    light: '#AFDDBF',
    contrastText: '#059436',
  },
  action: {
    disabled: '#D4DFF9',
    disabledBackground: '#D4DFF9',
    disabledOpacity: 1,
  },
};
